/**
 * @description Directory for ID Attributes on NewConfirmActionModal.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    divRoot: `newConfirmActionModal-div-root`,
    divHeader: `newConfirmActionModal-div-title`,
    divContent: `newConfirmActionModal-div-content`,
    divActions: `newConfirmActionModal-div-actions`,
    btnCancel: `newConfirmActionModal-btn-cancel`,
    btnConfirm: `newConfirmActionModal-btn-confirm`,
}

export default idDirectory
